module.exports = __webpack_public_path__ + "static/img/softwareShow.253ff69.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/softwareShow.jpg
// module id = t+Ov
// module chunks = 1